<script>
import { mapGetters } from 'vuex';
import MeetingEventNumber from './MeetingEventNumber.vue';
import MeetingsModalDesktop from './MeetingsModalDesktop.vue';
import ClickOutside from 'vue-click-outside';
export default {
  name: 'FormGuideMeetingHeaderDesktop',
  components: {
    MeetingEventNumber,
    MeetingsModalDesktop,
  },
  directives: {
    ClickOutside,
  },
  props: {
    activeEventNumber: {
      type: String,
      required: true,
    },
    activeView: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      modalActive: false,
    };
  },
  computed: {
    ...mapGetters({
      meeting: 'FormGuideMeetingHeader/getMeetingData',
    }),
    meetingData() {
      return this.meeting || {};
    },
    meetingEvents() {
      const { meetingData } = this;
      return meetingData.events
        ? meetingData.events.sort((a, b) => {
            return a.event_number - b.event_number;
          })
        : [];
    },
  },
  methods: {
    toggleMeetingsModal() {
      this.modalActive = !this.modalActive;
    },
    closeMeetingsModal() {
      this.modalActive = false;
    },
    updateMeetingSlug() {
      this.closeMeetingsModal();
    },
  },
};
</script>

<template>
  <div class="fg-meeting-header-desktop">
    <div class="fg-meeting-header-desktop__container">
      <a
        href="#"
        class="fg-meeting-header-desktop__meeting-selector"
        @click.prevent="toggleMeetingsModal"
      >
        <div class="fg-meeting-header-desktop__meeting-name">{{ meetingData.name }}</div>
        <div class="fg-meeting-header-desktop__dropdown-icon"></div>
      </a>
      <MeetingsModalDesktop
        v-click-outside="closeMeetingsModal"
        v-if="modalActive"
        @updateMeetingSlug="updateMeetingSlug"
      />
      <div class="fg-meeting-header-desktop__events">
        <template v-for="(event, index) in meetingEvents">
          <MeetingEventNumber
            :key="`meeting-event-no-${index}`"
            :event-id="event.id"
            :active-event-number="activeEventNumber"
            :active-view="activeView"
            :event-number="event.event_number"
            :event-status="event.status"
            :prefix-text="true"
          />
        </template>
      </div>
    </div>
  </div>
</template>
